import React from "react";
import { ContentHeaderView } from "components/shared";
import NonNachaTemplateListTable from "./components/NonNachaTemplateListTable";
import MobileNonNachaTemplateListTable from "./components/MobileNonNachaTemplateListTable";

import "./styles.css";

/**
 * @function NonNachaTemplateListWidget
 * @return {React.Component}
 * @exported true
 * @description This is the Non Nach Template List table widget for the NonNachaFileImportPage.
 */
export default function NonNachaTemplateListWidget(props) {
    return (
        <div className="non-nacha-template-list-widget">
            <ContentHeaderView text="Template List" />
            <div className="show-on-desktop">
                <NonNachaTemplateListTable />
            </div>
            <div className="show-on-mobile">
                <MobileNonNachaTemplateListTable />
            </div>
        </div>
    )
}
